import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {ApplyCouponCode} from '../../../Redux/AdminPanel/PurchaseCreditSlice'

const Promocodepopup = ({
  show,
  handleClose,
  price,
  noOfCredit,
  setMinCouponCredit,
  setCouponFlatRate,
  checkBox,
  setCouponId,
  setDiscount,
  setFlatRate,
  quickSms,
  setFreeCredit,
  setPercentage,
  setCouponCode,
  setManualCouponData,
}: any) => {
  const dispatch = useDispatch()
  const [coupon, setCoupon] = useState('')
  const [error, setError] = useState('')
  const verifyCoupon = () => {
    if (coupon) {
      const finalPrice = !checkBox
        ? (+noOfCredit * +price).toFixed(2)
        : ((+noOfCredit + +noOfCredit * 0.3) * +price).toFixed(2)

      dispatch(
        ApplyCouponCode({ coupon, amount: finalPrice, type: quickSms })
      ).then((res: any) => {
        if (res?.payload?.status) {
          const { metadata, id } = res?.payload?.data?.couponObj
          setManualCouponData(metadata)

          const minCredit = parseInt(metadata?.min_credit ?? "0", 10)
          const maxCredit = parseInt(metadata?.max_credit ?? "0", 10)
          const withinMin = !minCredit || noOfCredit >= minCredit
          const withinMax = !maxCredit || noOfCredit <= maxCredit
          const isEligible = withinMin && withinMax

          if (isEligible) {
            setCouponId(id)
            setCouponCode(coupon)

            if (metadata?.flat_rate && metadata?.discount_type === "fixed_price") {
              setFlatRate(+metadata.flat_rate)
              setDiscount(0)
              setCouponFlatRate(+metadata.flat_rate)
              setFreeCredit(0)
              setPercentage(0)
            }

            if (metadata?.discount_type === "percentage") {
              const discount = parseInt(metadata?.percentage_off ?? "0", 10)
              setDiscount(0)
              setFlatRate(0)
              setCouponFlatRate(0)
              setFreeCredit(0)
              setPercentage(discount)
            }

            if (metadata?.discount_type === "free_credit") {
              const freeCredit = parseInt(metadata?.free_credit ?? "0", 10)
              setDiscount(0)
              setFlatRate(0)
              setCouponFlatRate(0)
              setFreeCredit(freeCredit)
              setPercentage(0)
            }

            setMinCouponCredit(minCredit)
          } else {
            setCouponId("")
            setDiscount(0)
            setFlatRate(0)
            setMinCouponCredit(0)
            setFreeCredit(0)
            setPercentage(0)
            setCouponCode('')
          }
        } else {
          setCouponId("")
          setDiscount(0)
          setFlatRate(0)
          setMinCouponCredit(0)
          setFreeCredit(0)
          setPercentage(0)
          setCouponCode('')
        }

        setCoupon("")
      })
      handleClose()
    }
  }
  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-382px'
      className='vh-100 coupon-modal credit-modal'
      show={show}
      onHide={handleClose}
    >
      <div className=''>
        <div className='modal-header'>
          <h5 className='modal-title'>Apply coupon</h5>
          <button type='button' className='close' onClick={handleClose} aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
        </div>
        <div className='modal-body py-6'>
          <label>Coupon</label>
          <input
            onChange={(e: any) => setCoupon(e.target.value)}
            type='text'
            className='form-control form-control-lg form-control-solid mt-3 mb-lg-0'
            value={coupon}
          />

          <div className='d-flex justify-content-end modal-btn'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm btn-light text-hover-white bg-white btn-active-primary text-primary me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button type='submit' className='promoBtn btn btn-primary' onClick={verifyCoupon}>
              <span className='indicator-label'>Apply</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default Promocodepopup
